import React from 'react';
import styled from 'styled-components';

import { AnimatedLoadingPlaceholder } from '../../../../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';
import { CommonContainerStyle } from '../../styles';
import { ForecastIconLoadingUI } from '../common/forecastIconLoadingUI';

export const WeatherConditionsInfoLoadingUI = () => {
    return (
        <Container>
            <TemperatureInfoContainer>
                <AnimatedLoadingPlaceholder width={59} height='44px' key='large-temperature-loading-animation-ui' />
                <AnimatedLoadingPlaceholder width={81} height='13px' key='feels-like-loading-animation-ui' />
            </TemperatureInfoContainer>
            <ForecastIconLoadingUI />
        </Container>
    );
};

const Container = styled.div`
    ${CommonContainerStyle}
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 50%;
`;

const TemperatureInfoContainer = styled.div`
    ${CommonContainerStyle}
    width: calc(100% - 59px);
    line-height: 1;
    justify-content: space-between;
`;